module.exports = __webpack_public_path__ + "img/09.9700e640.png";